import { render, staticRenderFns } from "./creation-1.vue?vue&type=template&id=641fdbe2&scoped=true&"
import script from "./creation-1.vue?vue&type=script&lang=js&"
export * from "./creation-1.vue?vue&type=script&lang=js&"
import style0 from "./creation-1.vue?vue&type=style&index=0&id=641fdbe2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641fdbe2",
  null
  
)

export default component.exports